import { ValidatorFn } from "@angular/forms";
import { BasicDropdownType, DcSelectOptions, TableColTypes, TableCols } from "../interfaces/static-data";

export interface StaticDataFieldOptions {
    key: string;
    displayValue?: string;
    type?: TableColTypes;
    validators?: ValidatorFn[];
}

export const capitalize = (str: string, separator?: string | RegExp, lowerCaseRest = true): string => {
    if (typeof str !== 'string') {
        return '';
    }

    if (separator) {
        return str.split(separator).reduce((acc, current) => acc.concat(current.charAt(0).toUpperCase() + current.toLowerCase().slice(1)), []).join(' ')
    }

    return str.charAt(0).toUpperCase() + (lowerCaseRest ? str.toLowerCase() : str).slice(1);
}

export const mapToDropdownItem = (items: string[]): BasicDropdownType[] => {
    return items.map((item: string) => ({
      id: item,
      displayValue: capitalize(item, '_'),
    }));
}

export const createField = ({ key, type, validators, displayValue }: StaticDataFieldOptions): TableCols => ({
    key,
    displayValue: displayValue ?? capitalize(key, /(?=[A-Z])/),
    type,
    validators
})

export const createSelectField = (options: StaticDataFieldOptions, items: string[] | BasicDropdownType[], selectOptions?: DcSelectOptions): TableCols => ({
    ...createField(options),
    type: 'select',
    items: (isBasicDropdownTypeArray(items) ? items : mapToDropdownItem(items)),
    selectOptions,
});

export const createBooleanField = (options: StaticDataFieldOptions, items: string[] | BasicDropdownType[]): TableCols => ({
    ...createField(options),
    type: 'boolean',
    items: (isBasicDropdownTypeArray(items) ? items : mapToDropdownItem(items))
});

export const createToggleField = (options: StaticDataFieldOptions): TableCols => createField({ ...options, type: 'toggle' });

export const createDateField = (options: StaticDataFieldOptions): TableCols => createField({ ...options, type: 'date' });

export const createInputField = (options: StaticDataFieldOptions): TableCols => createField({ ...options, type: 'input' });

export const isBasicDropdownTypeArray = (item: any): item is BasicDropdownType[] => {
    if (!item.length) {
        return false;
    }

    return item[0].hasOwnProperty('id') && item[0].hasOwnProperty('displayValue');
}